import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Linkedin, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  const location = useLocation();
  const isSignupPage = location.pathname === '/signup';

  return (
    <footer className="pow-footer">
      <section className="container-fluid pow-footer__main">
        <div className="pow-footer__brand">
          <Link className="logo" to="/">
            <img
              className="pow-logo-img"
              src="/assets/img/panda/panda-logo.png"
              alt="PandaOnWheels"
            />
          </Link>
          <p className="pow-footer__tagline">
            Making workdays better with delicious meals &amp; happy teams.
          </p>
          <Link to="/signup" className="pow-btn pow-btn--red pow-footer__cta">
            Get Started
          </Link>
        </div>

        <div className="pow-footer__col">
          <h5>Company</h5>
          <ul>
            <li>
              <Link to="/about-us">About Us</Link>
            </li>
            <li>
              <Link to="/pricing">Pricing</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>

        <div className="pow-footer__col">
          <h5>Support</h5>
          <ul>
            <li>
              <Link to="/faq">Help Center</Link>
            </li>
            <li>
              <Link to="/faq">FAQs</Link>
            </li>
            <li>
              <Link to="/delivery-areas">Delivery Areas</Link>
            </li>
            <li>
              <Link to="/terms">Terms &amp; Conditions</Link>
            </li>
          </ul>
        </div>

        <div className="pow-footer__col">
          <h5>Stay Connected</h5>
          <p className="pow-footer__newsletter-text">
            Get lunch inspiration &amp; updates delivered to your inbox.
          </p>
          <form className="pow-footer__form" onSubmit={e => e.preventDefault()}>
            <input
              type="email"
              className="pow-footer__input"
              placeholder="Enter your email"
            />
            <button type="submit" className="pow-footer__submit" aria-label="Subscribe">
              <span className="arrow" />
            </button>
          </form>
          <div className="pow-footer__socials">
            {isSignupPage ? (
              <a
                href="https://www.instagram.com/pandaonwheels/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
            ) : (
              <>
                <a
                  href="https://www.linkedin.com/company/pandaonwheels"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <Linkedin size={18} />
                </a>
                <a
                  href="https://www.instagram.com/pandaonwheels/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <Instagram size={18} />
                </a>
                <a
                  href="https://facebook.com/pandaonwheels"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <Facebook size={18} />
                </a>
              </>
            )}
          </div>
        </div>
      </section>

      <section className="container-fluid text-center pow-footer__bottom">
        <small className="text-muted">
          © 2017 - {new Date().getFullYear()} PandaOnWheels. All rights
          reserved.
        </small>
      </section>
    </footer>
  );
};

export default Footer;
